module.exports = __webpack_public_path__ + "static/gallery2-18ee4ca0bc38d6caeb45ec8bb3d5b1f1.jpg";